import React from 'react';
import { RUN_SEND_HOLD_MESSAGE } from '@/utils/runSendRecovery';

export default function RunSendHoldNotice({ held, unqualified }) {
  return <p className="h-10 overflow-y-auto text-sm text-amber-900" role={held || unqualified ? 'status' : undefined}>
    {held ? RUN_SEND_HOLD_MESSAGE : unqualified ? 'This older plan needs send-history qualification before it can be sent. Local editing does not clear that requirement.' : ''}
  </p>;
}
